import React from 'react';
import Loader from '../../../assets/loader/Loader';

interface ButtonProps {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  bgColor?: string;
  icon?: React.ReactNode;
  textColor?: string;
  isLoader?: boolean;
  isDisabled?: boolean;
}

const ReusableButton: React.FC<ButtonProps> = ({
  variant,
  children,
  onClick,
  className,
  bgColor,
  icon,
  textColor,
  isLoader,
  isDisabled,
}) => {
  const baseClass =
    'px-4 py-2 rounded border-2  border-customBorder-border flex items-center justify-center m-2 ';

  // Define styles based on variant or custom bgColor
  const variantClass = bgColor
    ? `bg-[${bgColor}] ${textColor || 'text-white'} hover:bg-opacity-80`
    : variant === 'primary'
      ? 'bg-[#004E9B] text-white hover:bg-opacity-90'
      : `bg-[#004E9B] ${textColor || 'text-[#004E9B]'} border-[#004E9B] hover:bg-gray-100`;

  return (
    <button
      onClick={onClick}
      className={`${baseClass} ${variantClass} ${className}`}
      disabled={isLoader ?? isDisabled}
    >
      {isLoader ? (
        <Loader />
      ) : (
        <>
          {icon && <span className="mr-2">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
};

export default ReusableButton;
